import React, {useCallback, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";

const ScheduleNotificationBell = () => {
  const axiosPrivate = useAxiosPrivate();
  const {auth} = useAuth();
  const [count, setCount] = useState(0);

  const roles = Array.isArray(auth?.roles)
    ? auth.roles
    : typeof auth?.roles === "string"
      ? auth.roles.replace(/[\[\]\s]/g, "").split(",")
      : [];
  const enabled = roles.includes("ROLE_EMPLOYEE") || roles.includes("ROLE_MINION");

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const response = await axiosPrivate.get("/schedule-notifications/mine/unread-count");
      setCount(Number(response.data?.count || 0));
    } catch (error) {
      setCount(0);
    }
  }, [axiosPrivate, enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener("schedule-notifications-changed", refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("schedule-notifications-changed", refresh);
    };
  }, [enabled, refresh]);

  if (!enabled) return null;

  return (
    <Link className="qstaff-notification-bell" to="/app/notifications" title="Powiadomienia o grafiku" aria-label={`Powiadomienia: ${count} nieprzeczytanych`}>
      <span aria-hidden="true">🔔</span>
      {count > 0 && <span className="qstaff-notification-badge">{count > 99 ? "99+" : count}</span>}
    </Link>
  );
};

export default ScheduleNotificationBell;


